const PREFIX = "Shared/Portfolio/";

export const RECEIVE_PORTFOLIO = `${PREFIX}RECEIVE_PORTFOLIO`;
export const RECEIVE_PORTFOLIOS = `${PREFIX}RECEIVE_PORTFOLIOS`;
